import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PasiToast} from '@shared/models/toast.model';
import {UserProfile, UserProfileAddress, UserProfilePersonalData, UserProfileHealthInsurance, UserProfileContactData} from '@shared/models/user-profile.model';
import {ChangePassword} from '@shared/models/change-password.model';
import {InsuranceAddItem} from '@shared/models/insurance.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private http: HttpClient
  ) {
  }

  async getUserProfile(): Promise<UserProfile> {
    const url = '/api/v1/profile';
    return this.http.get<UserProfile>(url).toPromise();
  }

  async updateProfileAddress(model: UserProfileAddress): Promise<UserProfileAddress> {
    const url = '/api/v1/profile/address';
    return this.http.put<UserProfileAddress>(url, model).toPromise();
  }

  async updateHealthInsurance(model: UserProfileHealthInsurance): Promise<PasiToast> {
    const url = '/api/v1/profile/insurancePreferences';
    return this.http.put<PasiToast>(url, model).toPromise();
  }

  async updateContactData(model: UserProfileContactData): Promise<PasiToast> {
    const url = '/api/v1/profile/contacts';
    return this.http.put<PasiToast>(url, model).toPromise();
  }

  async updateProfilePersonalData(model: UserProfilePersonalData): Promise<PasiToast> {
    const url = '/api/v1/profile/personalData';
    return this.http.put<PasiToast>(url, model).toPromise();
  }

  async updatePassword(model: ChangePassword): Promise<PasiToast> {
    const url = `/api/v1/updatePassword`;
    return this.http.put<PasiToast>(url, model).toPromise();
  }

  async checkMatchPatient(model: UserProfile): Promise<UserProfile> {
    const url = `TODO`;
    return this.http.post<UserProfile>(url, model).toPromise();
  }

  addPatientInsurance(model: InsuranceAddItem): Promise<void> {
    const url = '/api/v1/insurance';
    return this.http.post<void>(url, model).toPromise();
  }
}
